module.exports = __webpack_public_path__ + "static/media/branding-logo.60e2aab6.png";